import { render, staticRenderFns } from "./destuffcargo.vue?vue&type=template&id=5ff824e3&scoped=true&"
import script from "./destuffcargo.vue?vue&type=script&lang=js&"
export * from "./destuffcargo.vue?vue&type=script&lang=js&"
import style0 from "./destuffcargo.vue?vue&type=style&index=0&id=5ff824e3&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff824e3",
  null
  
)

export default component.exports